import { Link, Navigate, Outlet, useLocation, useMatch } from 'react-router-dom';
import { Trans } from '@lingui/macro';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { Button } from 'components/ui/button';
import MainAppBar from 'components/MainAppBar';
import { useCustomerAuth } from 'context/CustomerAuthContext';

function CustomerAuthLoading() {
    return (
        <>
            <MainAppBar />
            <div
                role="status"
                className="flex min-h-[calc(100vh-64px)] items-center justify-center gap-3 px-3"
            >
                <Loader2 className="h-6 w-6 animate-spin" aria-hidden />
                <Trans>Loading your tickets...</Trans>
            </div>
        </>
    );
}

export function RequireCustomerAuth() {
    const { status, email, signOut } = useCustomerAuth();
    const location = useLocation();
    const eventPage = useMatch('/tickets/event/:eventId');
    if (status === 'loading') return <CustomerAuthLoading />;
    if (status !== 'authenticated') {
        const params = new URLSearchParams(location.search);
        params.delete('grant');
        return (
            <Navigate
                to={{
                    pathname: '/tickets',
                    search: params.toString() ? `?${params}` : '',
                    hash: location.hash,
                }}
                replace
                state={location.state}
            />
        );
    }
    return (
        <>
            <MainAppBar />
            <div className="mx-auto w-full max-w-screen-xl px-4 pt-4">
                <div className="flex items-center justify-end gap-3">
                    {eventPage && (
                        <Button asChild variant="outline" className="mr-auto shrink-0">
                            <Link to="/tickets/event" className="no-underline">
                                <ArrowLeft className="h-4 w-4" aria-hidden />
                                <Trans>All Events</Trans>
                            </Link>
                        </Button>
                    )}
                    <Button type="button" variant="outline" className="shrink-0" onClick={signOut}>
                        <Trans>Switch Email</Trans>
                    </Button>
                </div>
                {email && (
                    <span className="block break-all text-right text-sm text-muted-foreground mt-2">
                        {email}
                    </span>
                )}
            </div>
            <Outlet />
        </>
    );
}

export function CustomerLoginRoute() {
    const { status } = useCustomerAuth();
    const location = useLocation();
    if (status === 'loading') return <CustomerAuthLoading />;
    if (status === 'authenticated') {
        return (
            <Navigate
                to={{ pathname: '/tickets/event', search: location.search, hash: location.hash }}
                replace
                state={location.state}
            />
        );
    }
    return <Outlet />;
}

export function LegacyTicketLookupRedirect() {
    const location = useLocation();
    return (
        <Navigate
            to={{ pathname: '/tickets', search: location.search, hash: location.hash }}
            replace
            state={location.state}
        />
    );
}
